module.exports = __webpack_public_path__ + "img/kongtiao-select.b5b908d6.png";